import styles from "./PendingChannelsPopup.module.scss";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";

type Props = {
  visible: boolean;
  toggle: () => void;
  proceedBtnText: string;
  onProceed: () => void;
  onConnect: () => void;
};

// nudge shown when the user moves on with channels still disconnected or suggested
const PendingChannelsPopup = ({
  visible,
  toggle,
  proceedBtnText,
  onProceed,
  onConnect,
}: Props) => {
  return (
    <ConfirmDialog
      modalStyles={{ maxWidth: "450px" }}
      showButton={false}
      visible={visible}
      toggle={toggle}
      showCloseBtn={false}
      size={"md"}
    >
      <div className={styles.pendingChannelsContainer}>
        <div className={styles.topContainer}>
          <div className={styles.emoji}>💸</div>
          <div className={styles.title}>Don't settle for a smaller offer</div>
          <div className={styles.messageBanner}>
            Connect your missing channels so
            <br />
            we can give you the best we can.
          </div>
        </div>

        <div className={styles.bottomContainer}>
          <MeritoButton
            onClick={onProceed}
            size="lg"
            isRounded={true}
            btnType="button"
            type="tertiary"
            btnText={proceedBtnText}
          />
          <MeritoButton
            size="lg"
            onClick={onConnect}
            isRounded={true}
            btnType="button"
            type="primary-1"
            btnText="Connect Now"
          />
        </div>
      </div>
    </ConfirmDialog>
  );
};

export default PendingChannelsPopup;
